import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import SignHealthDocumentModal from '../../../../components/signHealthDocumentModal/signHealthDocumentModal';
import DocumentEditorDialog from '../documentEditor/documentEditorDialog';

// Editor, delete confirmation and signature modals, shared by the web and mobile lists.
export default function DocumentListDialogs({ patientId, screen }) {
  const { editor, deletion, signature } = screen;

  return (
    <>
      <DocumentEditorDialog
        open={editor.isEditorOpen}
        patientId={patientId}
        documentId={editor.editingDocumentId}
        onClose={editor.closeEditor}
        onSaved={editor.onDocumentSaved}
      />

      <Dialog
        open={deletion.deleteModal}
        onClose={deletion.closeDeleteModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Excluir documento</DialogTitle>
        <DialogContent dividers>
          <Typography>
            O documento <strong>{deletion.documentToDelete?.title}</strong> será excluído
            permanentemente e não poderá ser recuperado. Deseja continuar?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={deletion.closeDeleteModal}>Cancelar</Button>
          <Button variant="contained" color="error" onClick={deletion.handleConfirmDelete}>
            Excluir
          </Button>
        </DialogActions>
      </Dialog>

      <SignHealthDocumentModal
        open={!!signature.documentToSign}
        onClose={signature.closeSignModal}
        onSigned={signature.onSigned}
        onSign={(certificatePassword) => signature.signDocument(certificatePassword)}
        title="Assinar documento digitalmente"
        summary={signature.signSummary}
      />
    </>
  );
}

DocumentListDialogs.propTypes = {
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  screen: PropTypes.shape({
    editor: PropTypes.object.isRequired,
    deletion: PropTypes.object.isRequired,
    signature: PropTypes.object.isRequired,
  }).isRequired,
};
